import _replace from 'lodash/replace';

export default (value) => Number(_replace(value, ',', '.'));
